var content = require("!!../../node_modules/.pnpm/@angular-devkit+build-angular@0.803.29_@angular+compiler-cli@8.2.14_@angular+compiler@8.2.14__aes7mjm3jbmkkoabf3ip2lo4hm/node_modules/@angular-devkit/build-angular/src/angular-cli-files/plugins/raw-css-loader.js!../../node_modules/.pnpm/postcss-loader@3.0.0/node_modules/postcss-loader/src/index.js??embedded!../../node_modules/.pnpm/sass-loader@7.2.0_webpack@4.39.2/node_modules/sass-loader/lib/loader.js??ref--15-3!./variables.scss");

if (typeof content === 'string') {
  content = [[module.id, content, '']];
}

var options = {}

options.insert = "head";
options.singleton = false;

var update = require("!../../node_modules/.pnpm/style-loader@1.0.0_webpack@4.39.2/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js")(content, options);

if (content.locals) {
  module.exports = content.locals;
}
